import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ReportCenter from 'cccisd-report-center';
import { useParams } from 'cccisd-react-router';
import { client as apollo } from 'cccisd-apollo';
import classQuery from './groupList.graphql';
import Loader from 'cccisd-loader';

const Fortress = window.cccisd.fortress;

const MarketplaceReportCenter = () => {
    const [classList, setClassList] = useState([]);
    const [loading, setLoading] = useState(true);

    const { productId } = useSelector(state => state.app.products);
    const { productHandle } = useParams();

    useEffect(() => {
        async function start() {
            await initializeData();
        }
        start();
    }, []);

    async function getClassList() {
        const pawnId = Fortress.user.acting.id;

        const res = await apollo.query({
            query: classQuery,
            fetchPolicy: 'network-only',
            variables: { productId, pawnId },
        });

        return res.data;
    }

    async function initializeData() {
        const data = await getClassList();

        setClassList(data.roles.classList);

        setLoading(false);
    }

    if (loading) {
        return <Loader />;
    }

    if (classList.length === 0) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10rem' }}>
                <div>
                    <h2>
                        No groups were found.{' '}
                        <span role="img" aria-label="Thinking Emoji">
                            🤔
                        </span>
                    </h2>
                    <p>Please verify that groups have been created for this site.</p>
                </div>
            </div>
        );
    }
    return (
        <>
            {productHandle === 'ssgrin_ec' ? (
                <ReportCenter handle="ssgrin_ec_instructor_report_center" />
            ) : (
                <ReportCenter handle="ssgrin_k235_instructor_report_center" />
            )}
        </>
    );
};

export default MarketplaceReportCenter;
